// Ícono de Comunidad. Por ahora el globo (mundo), reconocible y prolijo.
// Cuando tengamos el SVG propio de Figma (un solo color) se cambia acá nomás.
import { FiGlobe } from "react-icons/fi";

export default function ComunidadIcon({ className, size }) {
  return <FiGlobe className={className} size={size} />;
}
